export default __webpack_public_path__ + "static/media/Keep_Dreaming.7f9f200a.png";